import { cn } from '@/lib/utils'
import { MARKETING_SECTION_TITLE } from '@/components/marketing/marketing-typography'
import { LANDING_ICON_REGISTRY, getLandingIcon } from '@/landing/landing-icon-registry'

export type MarketingFeatureItem = {
  icon: string
  title: string
  description: string
}

type MarketingFeatureGridProps = {
  title: string
  lead?: string
  items: readonly MarketingFeatureItem[]
  className?: string
}

function MarketingFeatureIcon({ icon }: { icon: string }) {
  if (icon in LANDING_ICON_REGISTRY) {
    const Icon = getLandingIcon(icon)
    return <Icon className="h-5 w-5" aria-hidden />
  }
  return <span aria-hidden>{icon}</span>
}

export function MarketingFeatureGrid({ title, lead, items, className }: MarketingFeatureGridProps) {
  return (
    <div className={className}>
      <h2 className={cn('m-0 mb-[18px] max-w-[800px]', MARKETING_SECTION_TITLE)}>
        {title}
      </h2>
      {lead ? (
        <p className="mb-10 max-w-[760px] text-lg leading-relaxed text-[var(--marketing-muted,#667078)]">{lead}</p>
      ) : null}
      <ul className="grid list-none grid-cols-1 gap-[18px] p-0 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item) => (
          <li
            key={item.title}
            className={cn(
              'min-h-[230px] rounded-[var(--radius-marketing-card,28px)] border border-[var(--marketing-border,#e9e3d6)]',
              'bg-[var(--marketing-card,#ffffff)] p-[26px] shadow-[0_22px_65px_rgba(31,37,40,0.045)]'
            )}
          >
            <div
              className="mb-[22px] flex h-11 w-11 items-center justify-center rounded-2xl bg-[var(--marketing-gold-soft,#fff3bf)] text-lg text-[var(--marketing-text,#1f2528)]"
              aria-hidden
            >
              <MarketingFeatureIcon icon={item.icon} />
            </div>
            <h3 className="mb-2.5 text-lg font-semibold">{item.title}</h3>
            <p className="m-0 text-base leading-relaxed text-[var(--marketing-muted,#667078)]">{item.description}</p>
          </li>
        ))}
      </ul>
    </div>
  )
}
